<!-- Default form grid -->
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html lang="en">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1.0" />
  <script type="text/javascript">
    const input = document.querySelector('input');
    input.valueAsDate = new Date();
  </script>
  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>
  <script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.5.6/angular.min.js"></script>
  <script src="./js/Script.js"></script>
  <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/angularjs/1.3.9/angular.min.js"></script>
  <script src="https://cdn.jsdelivr.net/npm/sweetalert2@11.10.6/dist/sweetalert2.all.min.js"></script>
  <link href="https://cdn.jsdelivr.net/npm/sweetalert2@11.10.6/dist/sweetalert2.min.css" rel="stylesheet" />
  <style>
    @media screen and (device-width: 360px) and (device-height: 640px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
    }

    .div1 {
      width: 60px;
      height: 30px;
      border: 1px solid blue;
    }
  </style>
</head>
<body>
  <div class="container">  
    <!-- <form #form="ngForm" formControlName="" name="ngForm" (ngSubmit)="onSubmit($event)" [formGroup]="imageForm">-->
    <!--<form #form="ngForm" formControlName="" name="ngForm" (ngSubmit)="onSubmit(admno,Student[0].amt2,AmountToPayC,bankname,creditdebitno,receivedamt,processdate,transdate,chequedrawn,branchaddress,cheqdraftdate,cheqdraftno,userInput,userInputW)">-->
    <form [formGroup]="UserForm" (ngSubmit)="onFormSubmit()">
      <!-- Grid row
  <br />
  <div class="row">
    <!-- Grid column -->
      <div class="row">
        <div class="col">
          <h3>{{GLBappFormName}} {{GLBappFormStarEnd}}</h3>
        </div>
      </div>
      <div class="row">
        <!-- Grid column -->
        <div class="col">
          <!-- Default input -->
          Date
          <input tabindex="1" type="date" [(ngModel)]="TodayDate" formControlName="TodayDate" style="font-weight: bold;" required />
        </div>
        <!-- Grid column -->
        <div class="col">
          <!-- Default input -->
          Enrol#
          <input tabindex="2" type="text" name="Admno" formControlName="Admno" id="Admno" [(ngModel)]="Admno" placeholder="Enrol/Admn No." required style="font-weight: bold;" />
        </div>
        <div class="col">
          <!-- Default input -->
          Student Rank
          <input tabindex="3" type="text" name="StudentRank" formControlName="StudentRank" id="StudentRank" [(ngModel)]="StudentRank" placeholder="Enter Student Rank" required style="font-weight: bold;" />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <!-- Default input -->
          Student Name
          <input tabindex="4" type="text" style="font-weight:bold" name="StudentName" formControlName="StudentName" id="StudentName" [(ngModel)]="StudentName" />
        </div>
        <div class="col">
          <!-- Default input -->
          Father's Name
          <input tabindex="5" type="text" style="font-weight:bold" name="FatherName" formControlName="FatherName" id="FatherName" [(ngModel)]="FatherName" />
        </div>
        <div class="col">
          <!-- Default input -->
          Mobile#
          <input tabindex="6" type="text" style="font-weight:bold" name="StudentMobile" formControlName="StudentMobile" id="StudentMobile" [(ngModel)]="StudentMobile" />
        </div>
        <!-- Grid column -->
      </div>
      <br />
      <div class="row">
        <div class="col">
        <!-- Default input -->
        Student Gender
        <select tabindex="7" formControlName="Gender" [(ngModel)]="Gender" id="Gender" name="Gender">
          <option value="Male" selected>Male</option>
          <option value="Female">Female</option>
          <option value="Others">Others</option>          
        </select>
        <!--<input formControlName="course" id="maxRno" type="number" [(ngModel)]="Student[0].maxRno" placeholder="Receipt No." name="maxRno" style="font-weight: bold;" readonly />-->
      </div>
        <div class="col">
          <!-- Default input -->
          Select Course
          <select tabindex="8" formControlName="StudentCourse" [(ngModel)]="StudentCourse" id="StudentCourse" name="StudentCourse">
            <option value="CSE">CSE</option>
            <option value="CSE-DS">CSE-DS</option>
            <option value="CSE-AIDS">CSE-AIDS</option>
            <option value="CSE-AIML" selected>CSE-AIML</option>
            <option value="ECE">ECE</option>
            <option value="IT">IT</option>
            <option value="EEE">EEE</option>
          </select>
          <!--<input formControlName="course" id="maxRno" type="number" [(ngModel)]="Student[0].maxRno" placeholder="Receipt No." name="maxRno" style="font-weight: bold;" readonly />-->
        </div>
        <div class="col">
          <!-- Default input -->
          Select Year
          <select tabindex="9" formControlName="StudYear" [(ngModel)]="StudYear" id="StudYear" name="StudYear">
            <option value="1st Year" selected>1st Year</option>
            <option value="2nd Year">2nd Year</option>
            <option value="3rd Year">3rd Year</option>
            <option value="4th Year">4th Year</option>
            <option value="LE 2nd Year">LE 2nd Year</option>
            <option value="LE 3rd Year">LE 3rd Year</option>
            <option value="LE 4th Year">LE 4th Year</option>
          </select>
        </div>
        <div class="col">
          <!-- Default input -->
          Academic Year
          <select tabindex="10" formControlName="AcademicYr" id="AcademicYr" [(ngModel)]="AcademicYr" name="AcademicYr">
            <option value="2026-2027" selected>2026-2027</option>
          </select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <!-- Default input -->
          Payment Mode
          <select tabindex="11" formControlName="ByPaymentMode" [(ngModel)]="ByPaymentMode" id="ByPaymentMode" name="ByPaymentMode">
            <option value="NEFT" selected>NEFT</option>
            <option value="UPI">UPI</option>
            <option value="Net Banking">Net Banking</option>
            <option value="Others">Others</option>
          </select>
          Ref. No.
          <input tabindex="12" type="text" style="font-weight:bold" [(ngModel)]="NetBankingRef" name="NetBankingRef" formControlName="NetBankingRef" id="NetBankingRef" />
        </div>
        <div class="col">
          <!-- Default input -->
          POS Machine (BQR/Auth.Code)
          <input tabindex="13" type="text" style="font-weight:bold" [(ngModel)]="PosMachineRef" name="PosMachineRef" formControlName="PosMachineRef" id="PosMachineRef" />
        </div>
      </div>
      <br />
      <div class="row" style="width:100%">
        <div class="col">
          <table formControlName="course" id="table1" style="width:auto" name="table1" class="table1">
            <thead>
              <tr>
                <th style="text-align: center;">S.No</th>
                <th style="text-align: left;">Particulars</th>
                <th style="text-align: center;">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: center; font-weight: bold;">1.</td>
                <td style="text-align: left; font-weight: bold;">Tuition Fee</td>
                <td><input tabindex="14" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="TuitFee" formControlName="TuitFee" id="TuitFee" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right;" #tutionfee /></td>
              </tr>
              <tr>
                <td style="text-align: center; font-weight: bold;">2.</td>
                <td style="text-align: left; font-weight: bold;">University Other Dues</td>
                <td><input tabindex="15" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="UniDues" type="number" placeholder="0" formControlName="UniDues" id="UniDues" style="width: 85px; font-weight: bold; text-align: right;" #univothdues /></td>
              </tr>
              <tr>
                <td style="text-align: center; font-weight: bold;">3.</td>
                <td style="text-align: left; font-weight: bold;">Book Bank</td>
                <td><input tabindex="16" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="BookBankFee" formControlName="BookBankFee" id="BookBankFee" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right; " #bookbank /></td>
              </tr>
              <tr>
                <td style="text-align: center; font-weight: bold;">4.</td>
                <td style="text-align: left; font-weight: bold;">Caution Money</td>
                <td><input tabindex="17" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="CautMoney" formControlName="CautMoney" id="CautMoney" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right;" #cautionmoney /></td>
              </tr>
              <tr>
                <td style="text-align: center; font-weight: bold;">5.</td>
                <td style="text-align: left; font-weight: bold;">Alumni Contribution</td>
                <td><input tabindex="18" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="AlumCont" formControlName="AlumCont" id="AlumCont" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right;" #alumcont /></td>
              </tr>
              <tr>
                <td style="text-align: center; font-weight: bold;">6.</td>
                <td style="text-align: left; font-weight: bold;">Examination Fee</td>
                <td><input tabindex="19" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="ExamFee" formControlName="ExamFee" id="ExamFee" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right;" #examfee /></td>
              </tr>
              <tr>
                <td style="text-align: center; font-weight: bold;">7.</td>
                <td style="text-align: left; font-weight: bold;">Innovation & Incubation Fee</td>
                <td><input tabindex="20" (input)="calculateTotal(tutionfee.value, bookbank.value, univothdues.value, cautionmoney.value, alumcont.value, examfee.value, innoincufee.value)" [(ngModel)]="InnoIncuFee" formControlName="InnoIncuFee" id="InnoIncuFee" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right;" #innoincufee /></td>
              </tr>
              <tr>
                <td></td>
                <td style="text-align: right; font-weight: bold;">Total Fees:</td>
                <input tabindex="200" [(ngModel)]="TotalAmt" formControlName="TotalAmt" id="TotalAmt" type="number" placeholder="0" style="width: 85px; font-weight: bold; text-align: right;" hidden />
                <td style="text-align: left; font-weight: bold;">{{ TotalAmt }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      Remarks
      <input tabindex="21" type="text" name="Remarks" id="Remarks" [(ngModel)]="Remarks" placeholder="" formControlName="Remarks" style="width:700px;font-weight: bold;" />
      <br /><br />
            <div class="form-group">
              <input tabindex="22" type="submit" name="submit" value="Submit" class="btn btn-success btn-lg btn-block" />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button type="button" class="btn btn-secondary btn-lg btn-block" (click)="PrintReceipt(0)">
                Print (Last Bill)
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Print in Paper Size A5 Portrait (Half of A4 size))
              <!--<input tabindex="20" type="button" name="Print" value="Print" class="btn btn-success btn-lg btn-block" style="background-color:darkblue" />-->
            </div>
      <br />
      <div class="form-group">
        <button class="btn btn-success btn-lg btn-block" style="background-color:darkorange" (click)="RefreshPage()">Refresh</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button type="button" class="btn btn-success btn-lg btn-block" style="background-color:darkmagenta" (click)="ShowAll()">Show All</button>
      </div>      
    </form>
    <div *ngIf="foundRecord == true">
    <span>Print Range:</span>    
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bill No from:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input tabindex="55" [(ngModel)]="BillNoFrom" formControlName="BillNoFrom" id="BillNoFrom" type="number" placeholder="0" style="width: 55px; font-weight: bold; text-align: center;" #billnofrom />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    Bill No to:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input tabindex="56" [(ngModel)]="BillNoTo" formControlName="BillNoTo" id="BillNoTo" type="number" placeholder="0" style="width: 55px; font-weight: bold; text-align: center;" #billnoto />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button type="button" class="btn btn-secondary btn-lg btn-block" (click)="PrintReceiptRange(billnofrom.value, billnoto.value)">
      Print In Range 
    </button>
      <div *ngIf="loading!=''" class="cssload-container">
        <div class="cssload-speeding-wheel"></div>
      </div>
      <div *ngIf="loading!=''" class='fullscreenDiv'>
        <div class="center">Loading...Please Wait</div>
      </div>
      <br /><br />
      <mat-form-field appearance="standard">
        <!--<mat-label>Search</mat-label>-->
        <input matInput (keyup)="applyFilter($event)" placeholder="Search Data" #input>
      </mat-form-field>
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <!-- Define Columns -->
      <ng-container matColumnDef="tid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Receipt#</th>
        <td mat-cell *matCellDef="let element">{{ element.tid }}</td>
      </ng-container>
      <ng-container matColumnDef="todayDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 150px;">R.Date</th>
        <td mat-cell *matCellDef="let element" style="width: 150px;">{{ element.todayDate | date:'dd-MM-yyyy'}}</td>
      </ng-container>
      <ng-container matColumnDef="admno">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Enrolment#</th>
        <td mat-cell *matCellDef="let element">{{ element.admno }}</td>
      </ng-container>
      <ng-container matColumnDef="studentRank">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rank</th>
        <td mat-cell *matCellDef="let element">{{ element.studentRank }}</td>
      </ng-container>
      <ng-container matColumnDef="studentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Name</th>
        <td mat-cell *matCellDef="let element">{{ element.studentName }}</td>
      </ng-container>
      <ng-container matColumnDef="fatherName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Father Name</th>
        <td mat-cell *matCellDef="let element">{{ element.fatherName }}</td>
      </ng-container>
      <ng-container matColumnDef="studentMobile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Mobile</th>
        <td mat-cell *matCellDef="let element">{{ element.studentMobile }}</td>
      </ng-container>
      <ng-container matColumnDef="byPaymentMode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Mode</th>
        <td mat-cell *matCellDef="let element">{{ element.byPaymentMode }}</td>
      </ng-container>
      <ng-container matColumnDef="totalAmt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amt. Paid</th>
        <td mat-cell *matCellDef="let element">{{ element.totalAmt }}</td>
      </ng-container>
       <ng-container matColumnDef="print">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Print</th>
        <td mat-cell *matCellDef="let element">
          <button style="align-content: center; background-color: #1b4f72; color: white; border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;" type="button" name="viewPrint" (click)="PrintReceipt(element.tid)">Print</button>
        </td>
      </ng-container>
       <ng-container matColumnDef="deleted">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cancel/Restore</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.deleted == 0">
            <button style="align-content: center; background-color: orangered; color: white; border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;" type="button" name="delrest" (click)="DRReceipt(element.tid, element.deleted)">Cancel Bill</button>
          </ng-container>
          <ng-container *ngIf="element.deleted == 1">
            <button style="align-content: center; background-color: forestgreen; color: white; border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;" type="button" name="delrest2" (click)="DRReceipt(element.tid, element.deleted)">Restore Bill</button>
          </ng-container>
        </td>
      </ng-container>

      <!-- Table Header and Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- Pagination -->
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]"></mat-paginator>
    </div>
    <script type="text/javascript">
      $(document).on('keypress', 'input', function (e) {
        if (e.which == 13) {
          e.preventDefault();
          var $next = $('[tabIndex=' + (+this.tabIndex + 1) + ']');
          if (!$next.length) {
            $next = $('[tabIndex=1]');
          }
          $next.focus().click();
        }
      });
    </script>
  </div>
</body>
</html>
